import { createSlice } from "@reduxjs/toolkit";

interface LoaderState {
  isLoading: boolean;
  activeRequests: number;
}

const initialState: LoaderState = {
  isLoading: false,
  activeRequests: 0,
};

const loaderSlice = createSlice({
  name: "loader",
  initialState,
  reducers: {
    showLoader: (state) => {
      state.activeRequests += 1;
      state.isLoading = true;
    },
    hideLoader: (state) => {
      state.activeRequests = Math.max(0, state.activeRequests - 1);
      if (state.activeRequests === 0) {
        state.isLoading = false;
      }
    },
    resetLoader: (state) => {
      state.activeRequests = 0;
      state.isLoading = false;
    },
  },
});

export const { showLoader, hideLoader, resetLoader } = loaderSlice.actions;
export default loaderSlice.reducer;
